import {
  PageResponse,
  PageTemplateCategoriesResponse,
  PageTemplate,
} from '@/core/typings/globals';
import { api } from '../index';

async function getPages(
  page?: number,
  status?: string,
  q?: string
): Promise<PaginatedResponse<PageResponse>> {
  const result = await api.get<PaginatedResponse<PageResponse>>(`api/pages`, {
    params: { status, q, page },
  });

  return result.data;
}

async function getPage(id): Promise<PageResponse> {
  const result = await api.get<PageResponse>(`api/pages/${id}`);
  return result.data;
}

async function createPage(
  name,
  slug,
  page_template_id,
  page_palette_id
): Promise<PageResponse> {
  const result = await api.post<PageResponse>(`api/pages`, {
    name,
    slug,
    page_template_id,
    page_palette_id,
  });
  return result.data;
}

async function updatePage(id, data): Promise<PageResponse> {
  const result = await api.put<PageResponse>(`api/pages/${id}`, data);
  return result.data;
}

async function duplicatePage(id): Promise<PageResponse> {
  const result = await api.post<PageResponse>(`api/pages/${id}/duplicate`);
  return result.data;
}

async function deletePage(id): Promise<void> {
  await api.delete<PageResponse>(`api/pages/${id}`);
}

async function unpublishPage(id): Promise<PageResponse> {
  const result = await api.post<PageResponse>(`api/pages/${id}/unpublish`);
  return result.data;
}

async function publishPage(id): Promise<PageResponse> {
  const result = await api.post<PageResponse>(`api/pages/${id}/publish`);
  return result.data;
}

async function getPageTemplates(): Promise<PageTemplate[]> {
  const result = await api.get<PageTemplate[]>(`api/page-templates`);
  return result.data;
}

async function getPageTemplateCategories(): Promise<
  PageTemplateCategoriesResponse
> {
  const result = await api.get<PageTemplateCategoriesResponse>(
    `api/page-template-categories`
  );
  return result.data;
}

async function setAsHomePage(id): Promise<PageResponse> {
  const result = await api.put<PageResponse>(
    `api/pages/${id}/set_as_home_page`
  );
  return result.data;
}

export default {
  getPages,
  getPage,
  createPage,
  updatePage,
  duplicatePage,
  deletePage,
  unpublishPage,
  publishPage,
  getPageTemplates,
  getPageTemplateCategories,
  setAsHomePage,
};
